import { IApiError } from '@frontend/request';

import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';
import {
  IActiveSessionDevice,
  IDemoAccountCreation,
  IDemoAccountCreationV1Params,
  IDemoSignUpParams,
  ILogoutDevicesParams,
  ISwitchMetatraderAccount,
  ISwitchMetatraderAccountParams,
  IUserDetail,
  userAccountAPI
} from '@aqx-core/common/api/user-account';

class UserAccountAPIController {
  public getAccounts = async (callbacks: IAPIControllerCallbacks<IUserDetail>) => {
    try {
      const { result } = await userAccountAPI.getAccounts();
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public switchMetatraderAccount = async (
    params: ISwitchMetatraderAccountParams,
    callbacks: IAPIControllerCallbacks<ISwitchMetatraderAccount>
  ) => {
    try {
      const { result } = await userAccountAPI.switchMetatraderAccount(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    } finally {
      callbacks.onFinally?.();
    }
  };

  public createDemoAccountWithoutLogin = async (
    params: IDemoAccountCreationV1Params,
    callbacks: IAPIControllerCallbacks<IDemoAccountCreation>
  ) => {
    try {
      const { result } = await userAccountAPI.createDemoAccountWithoutLogin(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public createDemoAccountWithLogin = async (
    params: IDemoAccountCreationV1Params,
    callbacks: IAPIControllerCallbacks<IDemoAccountCreation>
  ) => {
    try {
      const { result } = await userAccountAPI.createDemoAccountWithLogin(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getActiveSessionDevices = async (callbacks: IAPIControllerCallbacks<IActiveSessionDevice[]>) => {
    try {
      const { result } = await userAccountAPI.getActiveSessionDevices();
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public logoutDevices = async (params: ILogoutDevicesParams, callbacks: IAPIControllerCallbacks<boolean>) => {
    try {
      const { result } = await userAccountAPI.logoutDevices(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public demoSignUp = async (params: IDemoSignUpParams, callbacks: IAPIControllerCallbacks<IDemoAccountCreation>) => {
    try {
      const { result } = await userAccountAPI.demoSignUp(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public demoSignUpAuthenticated = async (
    params: IDemoSignUpParams,
    callbacks: IAPIControllerCallbacks<IDemoAccountCreation>
  ) => {
    try {
      const { result } = await userAccountAPI.demoSignUpAuthenticated(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };
}

export const userAccountAPIController = new UserAccountAPIController();
